import { render, staticRenderFns } from "./BluetoothPairing.vue?vue&type=template&id=12fdab82&"
import script from "./BluetoothPairing.vue?vue&type=script&lang=js&"
export * from "./BluetoothPairing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports